/**
 * Human-readable labels for control-center / finance alert type slugs.
 * Keep in sync with api/services/project_control_alerts.py alert `type` values.
 */

export const ALERT_TYPE_LABELS = {
    plan_over_actual         : 'Over plan (hours)',
    plan_under_actual        : 'Under pace (hours)',
    project_plan_over_actual : 'Project over plan (hours)',
    unplanned_labor          : 'Unplanned labor',
    margin_at_risk           : 'Margin at risk',
    cost_no_revenue          : 'Cost without revenue',
    margin_variance          : 'Margin variance',
    margin_alert             : 'Margin risk',
    forecast_overrun         : 'Forecast overrun',
    change_order_pending     : 'Change order pending',
    wip_billing              : 'WIP billing',
    ar_overdue               : 'AR overdue',
    subconsultant_billing    : 'Sub pass-through',
    staffing_gap             : 'Staffing gap',
    data_quality             : 'Data quality',
    phase_over_budget        : 'Phase over budget',
    phase_at_risk            : 'Phase at risk',
    phase_on_track           : 'Phase on track',
};

/**
 * Resolve a machine alert type slug to a display label.
 *
 * @param {string|null|undefined} type - Alert type slug from the API.
 * @returns {string} Human label, or a cleaned fallback when unknown.
 */
export const getAlertTypeLabel = (type) => {
    if (!type) {
        return '';
    }
    if (ALERT_TYPE_LABELS[type]) {
        return ALERT_TYPE_LABELS[type];
    }
    return String(type).replace(/_/g, ' ');
};

/**
 * Short title prefix for finance inbox attention rollups.
 *
 * @param {string|null|undefined} type
 * @returns {string}
 */
export const getAlertReviewTitlePrefix = (type) => {
    const label = getAlertTypeLabel(type);
    if (!label) {
        return 'Review project attention';
    }
    return `Review ${label.toLowerCase()}`;
};
